import { SlashMenuConfigExtension } from '@blocksuite/hive-widget-slash-menu';
import { BlockViewExtension, FlavourExtension } from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';
import { literal } from 'lit/static-html.js';

import { DatabaseBlockAdapterExtensions } from './adapters/extension.js';
import { databaseSlashMenuConfig } from './configs/slash-menu.js';

export const DatabaseBlockSpec: ExtensionType[] = [
  FlavourExtension('hive:database'),
  BlockViewExtension('hive:database', literal`hive-database`),
  DatabaseBlockAdapterExtensions,
  SlashMenuConfigExtension('hive:database', databaseSlashMenuConfig),
].flat();
